
import { Component, mixins } from "nuxt-property-decorator";
import BaseLayoutMixin from "../../node_modules/sitis-nuxt/lib/cms/BaseLayoutMixin";
import PageBreadcrumbs from "~/components/UI/Breadcrumbs.vue";

@Component({
  components: { PageBreadcrumbs },
  computed: {
    isCompanyPage: function () {
      return this.$route.path === '/company';
    },
  },
})
export default class MainLayout extends mixins(BaseLayoutMixin) {}
